import React from "react";
import { Card } from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { ContextMenuTrigger } from "react-contextmenu";
import DateWithOptions from "../../components/common/DateWithOptions";
import { Colxx } from "../../components/common/CustomBootstrap";
import { AWAITING_APPROVAL, INVALID_BOOKING, HOTEL_GUEST, CHECKED_OUT } from "../../constants/bookingStatusEnum";

const DataListView = ({ match, messages, booking, isSelect, collect, onCheckItem }) => {
  let bookingLabelColor = "booking_color awaiting col-1";

  if (booking.status) {
    switch (booking.status) {
      case AWAITING_APPROVAL:
        bookingLabelColor = "booking_color awaiting col-1";
        break;
      case INVALID_BOOKING:
        bookingLabelColor = "booking_color invalid col-1";
        break;
      case HOTEL_GUEST:
        bookingLabelColor = "booking_color approved col-1";
        break;
      case CHECKED_OUT:
        bookingLabelColor = "booking_color checked-out col-1";
        break;
      default:
        bookingLabelColor = "booking_color invalid col-1";
        break;
    }
  }

  return (
    <Colxx xxs="12" className="mb-2">
      <Link to={`${match.url}/${booking.id}`}>
        <ContextMenuTrigger id="menu_id" data={booking.id} collect={collect}>
          <Card
            className={classnames("d-flex flex-row", { active: isSelect })}
            style={{ overflow: "hidden" }}
          >
            <div className="d-flex">
              <div className={bookingLabelColor} />
            </div>

            <div className="pl-2 d-flex flex-grow-1 min-width-zero col-12">
              <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center col-12">
                <p className="truncate w-7 w-sm-100 col-sm-6 col-md-6 col-lg-2">
                  {`${booking.reservation_number ? `#${booking.reservation_number}` : "#"}`}
                </p>

                <p className="list-item-heading mb-1 truncate w-20 w-sm-100 col-sm-8 col-md-8 col-lg-4 ">
                  {`${booking.fullName}`}
                </p>

                <p className="mb-1 text-muted truncate text-one w-20 w-sm-100 col-sm-6 col-md-6 col-lg-2">
                  {`${messages["booking.room"]}: ${booking.rooms && booking.rooms.length ? booking.rooms.join(" , ") : "-"}`}
                </p>

                <p className="mb-1 text-one w-23 w-sm-100 col-sm-10 col-md-10 col-lg-4">
                  <span className="text-muted">Check-in: </span>
                  <DateWithOptions isComponent date={booking.checkin ? booking.checkin * 1000 : ""} /> <br />

                  <span className="text-muted">Check-out: </span>
                  <DateWithOptions isComponent date={booking.checkout ? booking.checkout * 1000 : ""} />
                </p>
              </div>
            </div>
          </Card>
        </ContextMenuTrigger>
      </Link>
    </Colxx>
  );
};

export default React.memo(DataListView);
